import { rankWith, and, uiTypeIs, schemaMatches } from '@jsonforms/core';
import { withJsonFormsEnumProps } from '@jsonforms/react';
import SelectItemDialogControl from '../../components/selectItemDialogControl';
import isEmpty from 'lodash/isEmpty';

const isSelectItemDialogControl = and(
  uiTypeIs('Control'),
  schemaMatches(
    (schema) => !isEmpty(schema) && schema.format === 'selectItemDialog'
  )
);

const materialCustomSelectItemDialogControlTester = rankWith(
  4,
  isSelectItemDialogControl
);

export default {
  tester: materialCustomSelectItemDialogControlTester,
  renderer: withJsonFormsEnumProps(SelectItemDialogControl),
};
